<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Inserisci opera"></app-toolkit-page-title>
            <form class="form" role="form" [formGroup]="criteriaForm">
                <div class="steppers">
                    <div class="steppers-content">
                        <ng-container *ngIf="stepper.currentStep === 1">
                            <div class="text-center mb-3">
                                <h3 class="primary-color">Selezionare la fonte di inserimento <small>(step 1 di 3)</small></h3>
                            </div>
                            <div class="d-flex justify-content-center">
                                <div class="steppers-button shadow-sm p-3 mb-3 mr-3 border border-light" (click)="setTipoInserimento(2)">
                                    <div class="d-flex justify-content-center">
                                        <app-toolkit-bl-icon icon="map-marker" cssClass="icon icon-primary icon-xl"></app-toolkit-bl-icon>
                                    </div>
                                    <div class="form-check">
                                        <input name="tipoInserimento" type="radio" id="rilievo" formControlName="tipoInserimento" [value]="2">
                                        <label for="rilievo">Da rilievo</label>
                                    </div>
                                </div>
                                <div class="steppers-button shadow-sm p-3 mb-3 border border-light" (click)="setTipoInserimento(1)">
                                    <div class="d-flex justify-content-center">
                                        <app-toolkit-bl-icon icon="folder" cssClass="icon icon-primary icon-xl"></app-toolkit-bl-icon>
                                    </div>
                                    <div class="form-check">
                                        <input name="tipoInserimento" type="radio" id="progetto" formControlName="tipoInserimento" [value]="1">
                                        <label for="progetto">Da progetto</label>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="stepper.currentStep === 2">
                            <div class="row">
                                <div class="col-8">
                                    <div class="text-right mb-3">
                                        <h3 class="primary-color">Informazioni dell'opera <small>(step 2 di 3)</small></h3>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end col">
                                    <div *ngIf="permessiService.opera['OPERA_CHANGE_ALL_STATO']">
                                        <div [formGroup]="formStato" class="form-group col">
                                            <label for="stato">Stato opera</label>
                                            <select (change)="setStatoOpera()" class="form-control" formControlName="stato" id="stato">
                                                <option *ngFor="let item of datalist.statoOpera" [ngValue]="item.id">{{ item.descrizione }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
                                <ngb-panel id="tab-1" title="Anagrafica dell'opera">
                                    <ng-template ngbPanelContent>
                                        <app-toolkit-opera-tab-anagrafica-opera [canEdit]="true" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-anagrafica-opera>
                                    </ng-template>
                                </ngb-panel>
                                <ngb-panel aria-busy="true" id="tab-2" title="Dati costruttivi dell'opera">
                                    <ng-template ngbPanelContent>
                                        <app-toolkit-opera-tab-dati-costruttivi-opera [canEdit]="true" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-dati-costruttivi-opera>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                            <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
                        </ng-container>
                        <ng-container *ngIf="stepper.currentStep === 3">
                            <div class="row">
                                <div class="col-8 text-right mb-3">
                                    <h3 class="primary-color">Conferma <small>(step 3 di 3)</small></h3>
                                </div>
                                <div class="d-flex justify-content-end col">
                                    <div *ngIf="permessiService.opera['OPERA_CHANGE_ALL_STATO']">
                                        <div [formGroup]="formStato" class="form-group col">
                                            <label for="stato">Stato opera</label>
                                            <select (change)="setStatoOpera()" class="form-control" formControlName="stato" id="stato">
                                                <option *ngFor="let item of datalist.statoOpera" [ngValue]="item.id">{{ item.descrizione }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
           
                            <p class="mb-3">Si vuole procedere con l'inserimento dell'opera?</p>
                        </ng-container>
                    </div>
                    <nav class="steppers-nav p-0">
                        <button type="button" class="btn btn-outline-primary steppers-btn-prev" (click)="stepperPrevious()" *ngIf="stepper.currentStep !== 1">Indietro</button>
                        <ul class="steppers-dots it25">
                            <li [class.done]="stepper.currentStep === 1" container="body" ngbTooltip="Step 1 di 3"><span class="sr-only">Selezionare la fonte di inserimento (step 1 di 3)</span></li>
                            <li [class.done]="stepper.currentStep === 2" container="body" ngbTooltip="Step 2 di 3"><span class="sr-only">Informazioni dell'opera (step 2 di 3)</span></li>
                            <li [class.done]="stepper.currentStep === 3" container="body" ngbTooltip="Step 3 di 3"><span class="sr-only">Conferma (step 3 di 3)</span></li>
                        </ul>
                        <button type="button" class="btn btn-primary steppers-btn-confirm" (click)="stepperNext()">{{ stepper.currentStep === 3 ? 'Conferma': 'Avanti' }}</button>
                    </nav>
                </div>
            </form>
        </div>
    </div>
</div>